/**
 * Semantic comparison for portal version strings in X.Y.Z format.
 *
 * Compares octet-by-octet as integers so "4.3.10" > "4.3.9"
 * (a plain string compare would get this wrong).
 *
 * Invalid or missing input is treated as "0.0.0".
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} negative if a<b, 0 if equal, positive if a>b
 */
export function compareVersion(a, b) {
  const pa = parseVersion(a);
  const pb = parseVersion(b);
  for (let i = 0; i < 3; i++) {
    if (pa[i] !== pb[i]) return pa[i] - pb[i];
  }
  return 0;
}

function parseVersion(v) {
  const parts = (typeof v === 'string' ? v : '').split('.').map((n) => parseInt(n, 10));
  return [parts[0] || 0, parts[1] || 0, parts[2] || 0];
}
